// Shared input sanitization for form fields.
//
// Strips characters commonly used in XSS / injection payloads while keeping
// everything real users need: letters of any language (Tamil, accents…),
// digits, spaces, and ordinary punctuation ( . , ' - / & @ + # etc.).
// Blocked set: <  >  {  }  (  )  $  `  ;  =  |  \  and the raw quote " '‌
// (angle brackets, braces, parens, template/expr chars).
//
// Use for name / company / message / subject style text fields.
// Do NOT use for email (handled by its own format check) or mobile
// (digits-only, handled separately).

const DANGEROUS_CHARS = /[<>{}()$`;=|\\]/g;

/** Remove dangerous/injection characters from a value (for onChange). */
export const stripDangerousChars = (value: string): string =>
  value.replace(DANGEROUS_CHARS, "");
